import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=218d3eb7&scoped=true&"
import script from "./Input.vue?vue&type=script&lang=js&"
export * from "./Input.vue?vue&type=script&lang=js&"
import style0 from "./Input.vue?vue&type=style&index=0&id=218d3eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d3eb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218d3eb7')) {
      api.createRecord('218d3eb7', component.options)
    } else {
      api.reload('218d3eb7', component.options)
    }
    module.hot.accept("./Input.vue?vue&type=template&id=218d3eb7&scoped=true&", function () {
      api.rerender('218d3eb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls2/Input.vue"
export default component.exports